<label (click)="uploader.clickUploader()" class="custom-file-upload">
    <mat-icon class="item-icon">upload_file</mat-icon>
    <span fxFlex="grow" class="tool-button-text" i18n> Upload file </span>
    <app-kd-logo-loading *ngIf="uploader.saving | async" size="small"></app-kd-logo-loading>
    <mat-icon class="qs-m" matTooltip="Upload file" i18n-matTooltip>question_mark</mat-icon>
</label>

<app-media-attachment
    #uploader
    [multiple]="false"
    type="file"
    dropLabel="Drop files"
    i18n-dropLabel
    (onUploadOrRemoveCompleted)="onUploadComplete($event)"
    (saving)="saving.emit($event)"
    [isCreateForm]="true"
    [isIconBtns]="true"
></app-media-attachment>
